import type { Relation, RelationMap } from '../../../types/relation';

export const getOrphans = (relations: RelationMap): Relation[] =>
  Object.values(relations).reduce<Relation[]>((orphans, node) => {
    const { parentId, nodeType } = node;

    if (parentId || nodeType === 'init') {
      return orphans;
    }

    orphans.push(node);

    return orphans;
  }, []);
